class SampleBox extends DrawerComponent {
  constructor() {
    super();
  }

  get requiresBodyAppended() {
    return false;
  }

  connectedCallback() {
    super.connectedCallback();

    this.limit = Number(this.getAttribute('data-limit'));

    if (!this.limit || isNaN(this.limit) || this.limit === 0 || !this.addToCartButton) {
      return;
    }

    document.addEventListener('sample-box:product-added', (e) => {
      const needsRerender = this.addSampleToBox(e.detail.productId);

      if (needsRerender) {
        this.render();
        this.validateAddToCartButton();
        super.show();
      }
    });

    document.addEventListener('sample-box:product-removed', (e) => {
      const needsRerender = this.removeFromSampleBox(e.detail.productId);

      if (needsRerender) {
        this.render();
        this.validateAddToCartButton();
      }
    });

    document.addEventListener('product-ajax:added', () => {
      this.hide();
    });

    this.render();
    this.validateAddToCartButton();
  }

  get addToCartButton() {
    return this.querySelector('button[type="submit"]');
  }

  get productsToRender() {
    return sessionStorage.getItem('sample-box') !== null ? JSON.parse(sessionStorage.getItem('sample-box')) : [];
  }

  validateAddToCartButton() {
    if (this.productsToRender.length === this.limit) {
      this.addToCartButton.removeAttribute('disabled');
    } else {
      this.addToCartButton.setAttribute('disabled', 'disabled');
    }
  }

  addSampleToBox(productId) {
    if (!productId) {
      return false;
    }

    if (this.productsToRender.length + 1 > this.limit) {
      return false;
    }

    if (productId && this.productsToRender.includes(productId)) {
      return false;
    }

    const newArray = this.productsToRender;
    newArray.push(productId);

    sessionStorage.setItem('sample-box', JSON.stringify(newArray));

    return true;
  }

  removeFromSampleBox(productId) {
    if (!productId) {
      return false;
    }

    if (productId && !this.productsToRender.includes(productId)) {
      return false;
    }

    const newArray = [];

    for (const item of this.productsToRender) {
      if (item === productId) {
        continue;
      }

      newArray.push(item);
    }

    sessionStorage.setItem('sample-box', JSON.stringify(newArray));

    return true;
  }

  validateProductsToRender(attribute) {
    try {
      const array = JSON.parse(attribute);
      let matching = true;

      for (const item of array) {
        if (!this.productsToRender.includes(item)) {
          matching = false;

          break;
        }
      }

      if (!matching) {
        this.resetSession();
        this.render();
      }
    } catch(e) {
      this.resetSession();
      this.render();

      console.log(e);

      return;
    }
  }

  resetSession() {
    sessionStorage.removeItem('sample-box');
  }

  updateCounters() {
    const elems = document.querySelectorAll('[data-sample-counter]');
    const toggleSamplesButton = document.querySelector('[data-toggle-samples]');

    if (toggleSamplesButton) {
      if (this.productsToRender.length === 0 && !toggleSamplesButton.classList.contains('hidden')) {
        toggleSamplesButton.classList.add('hidden');
      }

      if (this.productsToRender.length > 0 && toggleSamplesButton.classList.contains('hidden')) {
        toggleSamplesButton.classList.remove('hidden');
      }
    }

    for (const elem of elems) {
      if (this.productsToRender.length === 0 && elem.hasAttribute('data-hide')) {
        elem.setAttribute('hidden', '');
      } else {
        elem.removeAttribute('hidden');
      }

      elem.innerText = this.productsToRender.length;
    }
  }

  render() {
    const productsQuery = this.productsToRender.map(item => {
      return `id:${ item }`;
    }).join(' OR ');

    const limitQuery = ` OR boxlimit:${ this.limit }`;
    const renderQuery = productsQuery + limitQuery;

    fetch(`/search?q=${ renderQuery }&section_id=sample-items&type=product`, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(response => {
      return response.text();
    }).then(section => {
      const newElem = new DOMParser().parseFromString(section, 'text/html').querySelector('[data-content]');

      if (!newElem === null) {
        return;
      }

      const contentElem = newElem.firstElementChild;

      this.updateCounters();
      this.querySelector('form').querySelector('[data-items]').innerHTML = contentElem.innerHTML;
      this.validateProductsToRender(contentElem.getAttribute('data-products'));
    });
  }
}
customElements.define('sample-box', SampleBox);

class AddSample extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.productId = this.getAttribute('data-product-id');
    this.textContainer = this.querySelector('[data-text-target]');

    document.addEventListener('sample-box:customized-product-added', () => {
      if (this.textContainer) {
        this.updateLook();
      }
    });

    if (!this.productId) {
      return;
    }

    const addButton = this.querySelector('button');

    if (!addButton) {
      return;
    }

    addButton.addEventListener('click', () => {
      if (!this.state.includes(this.productId)) {
        document.dispatchEvent(new CustomEvent('sample-box:product-added', {
          detail: {
            productId: this.productId
          }
        }));
      } else {
        document.dispatchEvent(new CustomEvent('sample-box:product-removed', {
          detail: {
            productId: this.productId
          }
        }));
      }

      if (this.textContainer) {
        this.updateLook();
      }
    });

    if (this.textContainer) {
      this.updateLook();
    }
  }

  get state() {
    return sessionStorage.getItem('sample-box') !== null ? JSON.parse(sessionStorage.getItem('sample-box')) : [];
  }

  updateLook() {
    const addText = this.getAttribute('data-add-text');
    const removeText = this.getAttribute('data-remove-text');
    const added = this.state.includes(this.productId);

    if (!addText || !removeText) {
      return;
    }

    if (added) {
      this.textContainer.innerText = removeText;
    } else {
      this.textContainer.innerText = addText;
    }

    const addIcon = this.querySelector('[data-add-icon]');
    const removeIcon = this.querySelector('[data-remove-icon]');

    if (!addIcon || !removeIcon) {
      return;
    }

    if (added) {
      addIcon.setAttribute('hidden', '');
      removeIcon.removeAttribute('hidden');
    } else {
      addIcon.removeAttribute('hidden');
      removeIcon.setAttribute('hidden', '');
    }
  }
}
customElements.define('add-sample', AddSample);

class RemoveSample extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.productId = this.getAttribute('data-product-id');

    if (!this.productId) {
      return;
    }

    const removeButton = this.querySelector('button');

    if (!removeButton) {
      return;
    }

    removeButton.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('sample-box:product-removed', {
        detail: {
          productId: this.productId
        }
      }));
    });
  }
}
customElements.define('remove-sample', RemoveSample);